import GamaBulletins from "./bulletins/bulletins"

export default {
  GamaBulletins,
}
